export default __webpack_public_path__ + "static/Goles-2f5b3af6463164c1212b67b30591ccdb.png";